import { render } from "./ButtomIndex.vue?vue&type=template&id=2219943b&scoped=true"
import script from "./ButtomIndex.vue?vue&type=script&lang=js"
export * from "./ButtomIndex.vue?vue&type=script&lang=js"

import "./ButtomIndex.vue?vue&type=style&index=0&id=2219943b&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2219943b"]])

export default __exports__